export default "__VITE_ASSET__Dn_9kieO__"